import { render, staticRenderFns } from "./SpeakerBanner.vue?vue&type=template&id=2dec4214&scoped=true&"
import script from "./SpeakerBanner.vue?vue&type=script&lang=js&"
export * from "./SpeakerBanner.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerBanner.vue?vue&type=style&index=0&id=2dec4214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec4214",
  null
  
)

export default component.exports